import IBatteryStatus from '../../FrontApplet/Management/IBatteryStatus';
import { EmptyObject } from '../EmptyObject';
import { ManagementCapability } from '../../FrontApplet/Management/IManagement';

export type ManagementRequests =
	| ManagementSupportsRequest
	| ManagementGetModelRequest
	| ManagementGetSerialNumberRequest
	| ManagementGetTemperatureRequest
	| ManagementGetBrandRequest
	| ManagementGetBatteryStatusRequest
	| ManagementResetSettingsRequest
	| ManagementFactoryResetRequest
	| ManagementGetExtendedManagementUrlRequest
	| ManagementSetExtendedManagementUrlRequest
	| ManagementGetCapabilitiesRequest;

export const ManagementSupportsRequest = 'sos.Monitoring.App.ManagementSupportsRequest';
export interface ManagementSupportsRequest {
	type: typeof ManagementSupportsRequest;
	capability: string;
}

export const ManagementSupportsResult = 'sos.Monitoring.App.ManagementSupportsResult';
export interface ManagementSupportsResult {
	type: typeof ManagementSupportsResult;
	supports: boolean;
}

export const ManagementGetModelRequest = 'sos.Monitoring.App.ManagementGetModelRequest';
export interface ManagementGetModelRequest {
	type: typeof ManagementGetModelRequest;
}

export const ManagementGetModelResult = 'sos.Monitoring.App.ManagementGetModelResult';
export interface ManagementGetModelResult {
	type: typeof ManagementGetModelResult;
	model: string;
}

export const ManagementGetSerialNumberRequest = 'sos.Monitoring.App.ManagementGetSerialNumberRequest';
export interface ManagementGetSerialNumberRequest {
	type: typeof ManagementGetSerialNumberRequest;
}

export const ManagementGetSerialNumberResult = 'sos.Monitoring.App.ManagementGetSerialNumberResult';
export interface ManagementGetSerialNumberResult {
	type: typeof ManagementGetSerialNumberResult;
	serialNumber: string;
}

export const ManagementGetTemperatureRequest = 'sos.Monitoring.App.ManagementGetTemperatureRequest';
export interface ManagementGetTemperatureRequest {
	type: typeof ManagementGetTemperatureRequest;
}

export const ManagementGetTemperatureResult = 'sos.Monitoring.App.ManagementGetTemperatureResult';
export interface ManagementGetTemperatureResult {
	type: typeof ManagementGetTemperatureResult;
	temperature: number;
}

export const ManagementGetBrandRequest = 'sos.Monitoring.App.ManagementGetBrandRequest';
export interface ManagementGetBrandRequest {
	type: typeof ManagementGetBrandRequest;
}

export const ManagementGetBrandResult = 'sos.Monitoring.App.ManagementGetBrandResult';
export interface ManagementGetBrandResult {
	type: typeof ManagementGetBrandResult;
	brand: string;
}

export const ManagementGetBatteryStatusRequest = 'sos.Monitoring.App.ManagementGetBatteryStatusRequest';
export interface ManagementGetBatteryStatusRequest {
	type: typeof ManagementGetBatteryStatusRequest;
}

export const ManagementGetBatteryStatusResult = 'sos.Monitoring.App.ManagementGetBatteryStatusResult';
export interface ManagementGetBatteryStatusResult {
	type: typeof ManagementGetBatteryStatusResult;
	status: IBatteryStatus;
}

export const ManagementResetSettingsRequest = 'sos.Monitoring.App.ManagementResetSettingsRequest';
export interface ManagementResetSettingsRequest {
	type: typeof ManagementResetSettingsRequest;
}

export const ManagementResetSettingsResult = 'sos.Monitoring.App.ManagementRessetSettingsResult';
export interface ManagementResetSettingsResult {
	type: typeof ManagementResetSettingsResult;
	result: EmptyObject;
}

export const ManagementFactoryResetRequest = 'sos.Monitoring.App.ManagementFactoryResetRequest';
export interface ManagementFactoryResetRequest {
	type: typeof ManagementFactoryResetRequest;
}

export const ManagementFactoryResetResult = 'sos.Monitoring.App.ManagementFactoryResetResult';
export interface ManagementFactoryResetResult {
	type: typeof ManagementFactoryResetResult;
	result: EmptyObject;
}

export const ManagementGetExtendedManagementUrlRequest = 'sos.Monitoring.App.ManagementGetExtendedManagementUrlRequest';
export interface ManagementGetExtendedManagementUrlRequest {
	type: typeof ManagementGetExtendedManagementUrlRequest;
}

export const ManagementGetExtendedManagementUrlResult = 'sos.Monitoring.App.ManagementGetExtendedManagementUrlResult';
export interface ManagementGetExtendedManagementUrlResult {
	type: typeof ManagementGetExtendedManagementUrlResult;
	result: string | null;
}

export const ManagementSetExtendedManagementUrlRequest = 'sos.Monitoring.App.ManagementSetExtendedManagementUrlRequest';
export interface ManagementSetExtendedManagementUrlRequest {
	type: typeof ManagementSetExtendedManagementUrlRequest;
	url: string | null;
}

export const ManagementSetExtendedManagementUrlResult = 'sos.Monitoring.App.ManagementSetExtendedManagementUrlResult';
export interface ManagementSetExtendedManagementUrlResult {
	type: typeof ManagementSetExtendedManagementUrlResult;
	result: EmptyObject;
}

export const ManagementGetCapabilitiesRequest = 'sos.Monitoring.App.ManagementGetCapabilitiesRequest';
export interface ManagementGetCapabilitiesRequest {
	type: typeof ManagementGetCapabilitiesRequest;
}

export const ManagementGetCapabilitiesResult = 'sos.Monitoring.App.ManagementGetCapabilitiesResult';
export interface ManagementGetCapabilitiesResult {
	type: typeof ManagementGetCapabilitiesResult;
	result: ManagementCapability[];
}
